import { render } from "./PageTemp.vue?vue&type=template&id=9c1b02c4"
import script from "./PageTemp.vue?vue&type=script&lang=js"
export * from "./PageTemp.vue?vue&type=script&lang=js"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__